import CmsDapiArticle  from './cmsDapi/CmsDapiArticle';

class  CmsDapiModel {

    constructor (data) {
        this.data = data;
        this.articles = [];
        this.articlesById = {};
        this.hasArticles = false;

        if (data) {
            this.parseArticle(data);
        }
    }

    parseArticle (data = {}) {
        const { items = [] } = data;

        if (items && items.length) {
            let i = 0;
            const len = items.length;
            let article;

            for (; i < len; i++) {
                article = new CmsDapiArticle(items[i], false);
                if (article.slug && article.isRecap === false && article.isPreviewStory === false) {
                    this.articles.push(article);
                    this.articlesById[article.slug] = article;
                }
            }
        }

        this.hasArticles = this.articles.length > 0;

    }

}

export default CmsDapiModel;
